import React from 'react';
import { useBookContext } from '../../BookContext';
import { useSearchParams } from 'react-router-dom';
import MyLittleFunBookChapterView from './MyLittleFunBookChapterView';
import MyLittleFunBookChapterDetailView from './MyLittleFunBookChapterDetailView';

const MyLittleFunBookView = () => {
  const { book } = useBookContext();
  const [searchParams] = useSearchParams();
  const chapterId = searchParams.get('chapter');

  return (
    <div
      className={`book-my-little-fun-wrapper ${
        chapterId ? 'has-chapter chapter-' + chapterId : ''
      }`}>
      {!chapterId ? (
        <div className="book-my-little-fun-frame">
          <div className="book-my-little-fun-header-wrapper">
            <div className="book-my-little-fun-header-bg">
              <div className="my-little-fun-unit-logo" />
              <div className="my-little-fun-header">
                <div className="my-little-fun-unit-robot" />
                <div className="my-little-fun-unit-first-unit" />
                <div className="my-little-fun-unit-teddy" />
              </div>
            </div>
          </div>
          <div className="list-chapter">
            {book.chapters.map((c, i) => (
              <MyLittleFunBookChapterView key={i} chapter={c} index={i} />
            ))}
          </div>
        </div>
      ) : (
        <MyLittleFunBookChapterDetailView chapterId={chapterId} />
      )}
    </div>
  );
};

export default MyLittleFunBookView;
